import * as React from 'react';
import styled from 'styled-components';
import { QuerySuggestions } from '@packages/common';

import { themeGet, is } from '../../theme/utils';
import { media } from '../../theme/media';
import { Highlight } from './Highlight/Highlight';

export const AutoSuggestListStyled = styled.ul`
  position: absolute;
  left: 0;
  width: 100%;
  top: 100%;
  background: white;
  list-style: none;
  padding: 0;
  margin: 0;
  box-shadow: 0 0 14px -3px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

export const AutosuggestListLi = styled.li<{ active: boolean }>`
  cursor: pointer;
  padding: 12px ${themeGet.space(5)};
  font-size: ${themeGet.fontSize(6)};

  ${is('active')`
    background-color: ${themeGet.colors('swirl')};
  `};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${themeGet.colors('mercury')};
  }

  ${media.from.md`
    padding-left: ${themeGet.space(6)};
    padding-right: ${themeGet.space(6)};
  `};
`;

export type AutoSuggestHit = {
  query: string;
  objectID: string;
  [key: string]: any;
};

export interface AutosuggestListProps {
  hits?: QuerySuggestions[];
  handleSelect: (hit: QuerySuggestions, position: number) => void;
  activeIndex?: number;
  className?: string;
}

export type AutoSuggestSelection = {
  algoliaMetaData: {
    objectID: string;
    position: number;
    indexName: string;
    queryID: string;
  };
};

export type AutosuggestListItemProps = {
  hit: QuerySuggestions;
  active: boolean;
  onClick: VoidFunction;
};

export const AutosuggestListItem: React.FC<AutosuggestListItemProps> = ({ hit, active, onClick }) => {
  return (
    <AutosuggestListLi active={active} onClick={(_e: any) => onClick()} key={hit.objectID}>
      <Highlight hit={hit} attribute="query" />
    </AutosuggestListLi>
  );
};

export const AutosuggestList: React.FC<AutosuggestListProps> = ({
  hits = [],
  activeIndex,
  handleSelect,
  className,
}) => {
  return (
    <AutoSuggestListStyled className={className}>
      {hits.map((hit, index) => (
        <AutosuggestListItem
          key={`autosuggest-${index}-${hit.query}`}
          active={index === activeIndex}
          onClick={() => handleSelect(hit, index)}
          hit={hit}
        />
      ))}
    </AutoSuggestListStyled>
  );
};
